export default {
  type: "string",
  description: "Refresh token obtained in first step",
  example: "Xw7...moVo"
};
